export default __webpack_public_path__ + "static/media/Panoramica2.1882a3c8.jpeg";